// extracted by mini-css-extract-plugin
export default {"grid":"TimeSlotGrid_grid__jXNY9","slot":"TimeSlotGrid_slot__4ypHw","slotSelected":"TimeSlotGrid_slotSelected__H1G+h"};